import esquire from "@/types/clients/esquire";
import PostImageRequest from "@/types/clients/esquire/requests/general/post-image-request";
import GetPassport from "@/types/clients/esquire/requests/general/get-passport";
import PutPassportConfirmUpdate from "@/types/clients/esquire/requests/general/put-passport-confirm-update";
import { UpdatePassportPayload } from "@/types/clients/esquire/payloads/update-passport-payload";
import Passport from "@/types/clients/esquire/data/general/passport";
import Contract from "@/types/clients/esquire/data/general/contract";
import Reservation from "@/types/clients/esquire/data/general/reservation";
import PutGuestUpdate from "@/types/clients/esquire/requests/checkin/put-guest-update";
import UpdateGuestPayload from "@/types/clients/esquire/payloads/update-guest-payload";
import GlobalService from "@/services/global-service";
import ManualPassport from "@/types/clients/esquire/data/general/manual-passport";
import PostManualPassportPayload from "@/types/clients/esquire/payloads/post-manual-passport-payload";
import PostManualPassport from "@/types/clients/esquire/requests/general/post-manual-passport";

export const postImageRequest = new PostImageRequest(esquire);
export const getPassportRequest = new GetPassport(esquire);
export const putPassportConfirmUpdateRequest = new PutPassportConfirmUpdate(esquire);
export const putGuestUpdateRequest = new PutGuestUpdate(esquire);
export const postManualPassportRequest = new PostManualPassport(esquire);

class PassportService {

  async uploadPassportImage(contractId: string, file: File): Promise<Passport | null> {
    return await postImageRequest.send(contractId, file);
  }

  async fetchPassport(): Promise<Passport | null> {
    return await getPassportRequest.send();
  }

  async confirmPassport(passport: Passport, reservation: Reservation, contract: Contract, isConfirmed: boolean, isConfirmedByGuest: boolean): Promise<void> {
    const payload: UpdatePassportPayload = {
      is_confirmed: isConfirmed,
      is_confirmed_by_guest: isConfirmedByGuest
    };

    await putPassportConfirmUpdateRequest.send(passport.id, payload);

    const targetContractIndex = reservation.contracts.findIndex((c: Contract) => c.id === contract.id);
    if (targetContractIndex !== -1) {
      const targetContract = reservation.contracts[targetContractIndex];
      if (targetContract.guest) {
        targetContract.guest.firstName = passport.firstName ?? "";
        targetContract.guest.lastName = passport.lastName ?? "";

        reservation.contracts[targetContractIndex] = targetContract;

        const updatePayload = new UpdateGuestPayload(targetContract.guest, reservation.id);
        await putGuestUpdateRequest.send(updatePayload);
      }
    }
  }

  async postManualPassport(passport: ManualPassport, contractId: string): Promise<boolean> {
    const payload = new PostManualPassportPayload(passport, contractId);
    return await postManualPassportRequest.send(payload);
  }

  async skipPassportCheckin(contractId: string): Promise<boolean> {
    const response = await GlobalService.esquire().contracts().postContractNote(contractId, "skip_passport");
    return response.code === 200;
  }

}

export default new PassportService();
